  document.querySelectorAll('.menu-dropdown').forEach(function(dropdown) {
    dropdown.addEventListener('change', function() {
      const url = this.value;
      if (url) {
        window.location.href = url;
      }
    });
  });





             $(document).ready(function(){
          $('.collection-image-wrap-get .collection_grid').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
               centerMode: true,
    centerPadding: '150px',
            speed: 300,
            prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-arrow-left' aria-hidden='true'></i></button>",
      nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-arrow-right' aria-hidden='true'></i></button>",
            autoplaySpeed: 5000,
            autoplay: true,
            responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
            }
          }
              ,
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
            }
          }
        ]
          });
        });






             $(document).ready(function(){
          $('.collection-wrap .collection_grid').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            speed: 300,
            prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-arrow-left' aria-hidden='true'></i></button>",
      nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-arrow-right' aria-hidden='true'></i></button>",
            autoplaySpeed: 5000,
            autoplay: true,
            responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
            }
          }
              ,
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
            }
          }
        ]
          });
        });



// Faq //
$(function () {
  $('.mn-faq').each(function () {
    var $faqSection = $(this);

    // Open first FAQ item within this section
    $faqSection.find(".js-faq-title").first().addClass("faq__active");
    $faqSection.find(".js-faq-content").first().slideDown(0);
    $faqSection.find('.js-faq-rotate').first().addClass('faq__rotate');

    $faqSection.on("click", ".js-faq-title", function (e) {
      e.preventDefault();
      var $this = $(this);

      if (!$this.hasClass("faq__active")) {
        $faqSection.find(".js-faq-content").slideUp(800);
        $faqSection.find(".js-faq-title").removeClass("faq__active");
        $faqSection.find('.js-faq-rotate').removeClass('faq__rotate');
      }

      $this.toggleClass("faq__active");
      $this.next().slideToggle();
      $('.js-faq-rotate', this).toggleClass('faq__rotate');
    });
  });
});



function initMobileSlider() {
  if ($(window).width() < 768) {
    if (!$('.announcement_cnt').hasClass('slick-initialized')) {
      $('.announcement_cnt').slick({
        dots: false,
        arrows: false,
        autoplay: false,
        infinite: true,
      });
    }
  } else {
    if ($('.announcement_cnt').hasClass('slick-initialized')) {
      $('.announcement_cnt').slick('unslick');
    }
  }
}

$(document).ready(function () {
  initMobileSlider();
});

$(window).on('resize', function () {
  initMobileSlider();
});





          $(document).ready(function(){
    $('.our-partner_flex_cnt_list_sty').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 0, // zero delay between scrolls
      speed: 6000, // smooth speed for continuous feel
      cssEase: 'linear', // linear animation for continuous scroll
      infinite: true,
      arrows: false,
      dots: false,
      pauseOnHover: false,
      variableWidth: true
    });
  });